import React from 'react';
import { connect } from 'react-redux';
import { Header, Grid, Label, Loader } from 'semantic-ui-react';
import { isBrowser } from 'react-device-detect';
import { toTitleCase } from '../../app/common/util';
import PropTypes from 'prop-types';
import './dashboard.css';
import SavedCards from '../savedCards';
import BankAccount from '../bankAccounts';
import CustomNavLink from '../nav/SideBar/component/CustomNavLink';
import { isMobile } from 'react-device-detect';

const mapState = state => ({
  isLoggedIn: (state.auth.isLoggedIn && state.auth.isLoggedIn.result) || false,
  auth: state.auth,
  async: state.async,
  payment: state.payment
});

class DashboardContainer extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    async: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    payment: PropTypes.object
  };

  render() {
    const {
      async,
      auth: { profile },
      payment
    } = this.props;

    return (
      <div>
        <div id="feature-dashboard">
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={8} className={!isMobile ? "verticalSeparator" : ''}>
                <Grid>
                  {isBrowser && (
                    <React.Fragment>
                      <Grid.Row>
                        <Grid.Column width={16}>
                          <Header.Content as="h2">
                            <CustomNavLink to="profile">
                              {profile && toTitleCase(profile.name)}{' '}
                              {profile && toTitleCase(profile.lastName)}
                            </CustomNavLink>

                            <Header.Subheader as="span" className="email">
                              {profile && profile.email}
                              <Header.Subheader as="span" className="phone">
                                {profile && profile.mobileNo}
                              </Header.Subheader>
                            </Header.Subheader>
                          </Header.Content>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={8}>
                          <h2 className="totalBalance rupeeIcon">
                            Balance{' '}
                            <span>
                              {payment.balance && payment.balance.totalBalance}
                            </span>
                            {/* <BalanceInfo payment={payment} iconWidth="11px" /> */}
                            <Loader
                              active={
                                async.loading &&
                                !(
                                  payment.balance &&
                                  payment.balance.totalBalance
                                )
                              }
                              inline
                              size="small"
                            />
                            {!async.loading &&
                              !(
                                payment.balance && payment.balance.totalBalance
                              ) && (
                                <Label basic color="red" size="large">
                                  Server Error!
                                </Label>
                              )}
                          </h2>
                        </Grid.Column>

                        <Grid.Column width={8}>
                          <CustomNavLink to="cash" className="buttonAddMoney">
                            Add Money
                          </CustomNavLink>
                        </Grid.Column>
                      </Grid.Row>
                    </React.Fragment>
                  )}

                  <Grid.Row>
                    <BankAccount inlineLoad={true} />
                  </Grid.Row>
                </Grid>
              </Grid.Column>

              <Grid.Column width={8}>
                <SavedCards inlineLoad={true} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

export default connect(
  mapState
)(DashboardContainer);
